// =======================
// CONSTANTS: Library
// =======================
export enum Library {
    DOCUMENTS = "Documents",
    WORKFLOWS = "Workflows",
  }